import {isNullOrUndefined} from "../../../services/Validator";

export default function HomeFooterNavigationListTitleText({title}) {
    // Used in HomeFooterMainNavigationList to display navigation links
    // group title text

    // BUILD
    if (isNullOrUndefined(title)) {
        return null
    }
    return (
        <span className={"font-bold text-[16px] text-backgroundLight3"}>
            {title}
        </span>
    )
}